module.exports = __webpack_public_path__ + "static/media/support.6abaea2f.svg";